<template>
  <div class="dod-container">
    <dod-view-title
      :title="
        selectedCustomerStatus ? selectedCustomerStatus.name : 'Niepełny grafik'
      "
    />
    <dod-search-input
      :with-filters="true"
      :filter-settings="['DEPARTMENT', 'PRIORITY_STATUS', 'SCOPE_OF_CARE']"
      @search="handleSearch"
      @onFilter="handleFilters"
    />
    <pagination-arrows
      v-if="customers.meta && customers.meta.total > 0"
      :onPage="customers.meta.per_page"
      :pageNumber="customers.meta.current_page"
      :total="customers.meta.total"
      @nextPage="handleNextPage"
      @previousPage="handlePreviousPage"
    />

    <div
      class="list"
      v-if="customers && customers.data && customers.data.length > 0"
    >
      <customer-card
        :customer="customer"
        v-for="customer in customers.data"
        :key="customer.id"
      />
    </div>
    <dod-empty-list v-else />
  </div>
</template>

<script>
import CustomerCard from "../../components/dod/CustomerCard.vue";
import DodEmptyList from "../../components/dod/DodEmptyList.vue";
import DodSearchInput from "../../components/dod/DodSearchInput.vue";
import DodViewTitle from "../../components/dod/DodViewTitle.vue";
import PaginationArrows from "../../components/PaginationArrows.vue";
export default {
  components: {
    CustomerCard,
    DodViewTitle,
    DodSearchInput,
    DodEmptyList,
    PaginationArrows,
  },
  name: "DODCustomers",
  data() {
    return {
      searchValue: "",
      filters: {
        withoutScheduleJoin: true,
      },
      page: 1,
      limit: 20,
    };
  },

  async mounted() {
    //await this.$store.dispatch("fetchCustomerStatuses");

    if (
      this.$route.name === "Customers" &&
      !this.selectedCustomerStatus &&
      this.customerStatuses[0]
    ) {
      if (this.urlNotScheduled) {
        const notFillScheduleStatus = this.customerStatuses.find(
          (status) => status.name === "Niepełny grafik"
        );
        this.$router.push({
          name: "Customers",
          query: {
            status: "",
            notScheduled: 1,
            type: notFillScheduleStatus
              ? notFillScheduleStatus.name.toLowerCase().replace(" ", "_")
              : "",
          },
        });
        this.$store.dispatch(
          "setSelectedCustomerStatus",
          notFillScheduleStatus
        );
        this.$store.dispatch(
          "setSelectedLeftBarLink",
          notFillScheduleStatus?.name
        );
      } else if (this.urlStatusId) {
        const statusFromUrl = this.customerStatuses.find(
          (status) => status.id === this.urlStatusId
        );
        this.$store.dispatch("setSelectedCustomerStatus", statusFromUrl);
        this.$store.dispatch("setSelectedLeftBarLink", statusFromUrl?.name);
      } else {
        this.$router.push({
          name: "Customers",
          query: {
            status: this.customerStatuses[0].id,
            notScheduled: 0,
            type: this.customerStatuses[0].name.toLowerCase().replace(" ", "_"),
          },
        });
        this.$store.dispatch(
          "setSelectedCustomerStatus",
          this.customerStatuses[0]
        );
        this.$store.dispatch(
          "setSelectedLeftBarLink",
          this.customerStatuses[0].name
        );
      }
    }

    await this.fetchCustomers(
      this.urlStatusId,
      this.searchValue,
      this.urlNotScheduled,
      this.filters
    );
  },

  destroyed() {
    this.$store.dispatch("setSelectedCustomerStatus", null);
    this.$store.dispatch("setSelectedLeftBarLink", null);
  },

  computed: {
    customerStatuses() {
      return this.$store.getters.getCustomerStatuses;
    },
    customers() {
      return this.$store.getters.getDodCustomers;
    },
    urlQuery() {
      return this.$route.query;
    },
    urlStatusId() {
      return this.urlQuery.status;
    },
    urlNotScheduled() {
      return this.urlQuery.notScheduled;
    },
    selectedCustomerStatus() {
      return this.$store.getters.getSelectedCustomerStatus;
    },
  },

  watch: {
    async urlQuery() {
      this.page = 1;
      if (
        !this.urlStatusId &&
        !this.urlNotScheduled &&
        this.customerStatuses[0]
      ) {
        this.$router.push({
          name: "Customers",
          query: {
            status: this.customerStatuses[0].id,
            notScheduled: 0,
            type: this.customerStatuses[0].name.toLowerCase().replace(" ", "_"),
          },
        });
        this.$store.dispatch(
          "setSelectedCustomerStatus",
          this.customerStatuses[0]
        );
        this.$store.dispatch(
          "setSelectedLeftBarLink",
          this.customerStatuses[0].name
        );
      }

      await this.fetchCustomers(
        this.urlStatusId,
        this.searchValue,
        this.urlNotScheduled,
        this.filters
      );
    },
  },

  methods: {
    async handleNextPage() {
      this.page++;
      await this.fetchCustomers(
        this.urlStatusId,
        this.searchValue,
        this.urlNotScheduled,
        this.filters
      );
    },
    async handlePreviousPage() {
      this.page--;
      await this.fetchCustomers(
        this.urlStatusId,
        this.searchValue,
        this.urlNotScheduled,
        this.filters
      );
    },

    async handleSearch(searchValue) {
      this.searchValue = searchValue;
      await this.fetchCustomers(
        this.urlStatusId,
        this.searchValue,
        this.urlNotScheduled,
        this.filters
      );
    },

    async handleFilters(filters) {
      this.filters = {};
      if (filters) {
        filters.forEach((filter) => (this.filters[filter.key] = filter.value));
      }

      await this.fetchCustomers(
        this.urlStatusId,
        this.searchValue,
        this.urlNotScheduled,
        this.filters
      );
    },

    async fetchCustomers(statusId, search, notScheduled, filters) {
      await this.$store.dispatch("getDodCustomers", {
        statusId,
        search,
        notScheduled,
        filters,
        page: this.page,
        limit: this.limit,
      });
    },
  },
};
</script>

<style scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0;
}
</style>
